import { isEmpty } from 'lodash'
import localforage from 'localforage'
import UserService from '@/services/user.service'
import TenantService from '@/services/tenant.service'
import { defineRulesFor}  from '@/config/ability'
import Router from '@/routes'

export const login = ({ dispatch }, { payload, context }) => {
  return UserService.login(payload)
    .then(response => {
      dispatch('setToken', response.data.token).then(() => {
        dispatch('fetchUser', context)
      })
    })
    .catch(error => {
      context.errors = error.response.data
    })
}

export const fetchTenant = ({ commit }) => {
  return TenantService.me().then(response => {
    commit('SET_TENANT', response.data.tenant.profile, { root: true })
  })
}

export const fetchUser = ({ commit, dispatch }, context) => {
  return UserService.me().then(response => {
    commit('setAuthenticated', true)
    //commit('SET_LAYOUT', 'default-layout', { root: true })
    if (response.data.roles.includes('ROLE_ADMIN')) {
      let makeParams = null
      //if(response.data.tenant.profile.knumber === 'K10151') {
      //  makeParams = { opendamagesMax: 1999 }
      //}
      commit('setIsAdmin', true)
      dispatch('getStats', makeParams, { root: true })
      dispatch('getConfig', null, { root: true })
      if(Router.currentRoute.name !== 'VehicleIndex' && Router.currentRoute.name !== 'vehicle-details' ) {
        Router.push({ name: 'admin.dashboard' })
      }
    }
    commit('setUserData', response.data)
    dispatch('getMerchantConfig', null, { root: true })
    dispatch('getCartCount', null, { root: true })
    dispatch('getCart', null, { root: true })
    dispatch('getBanners', null, { root: true })
    dispatch('getVehicleCount', makeParams, { root: true })
    let makeParams = null
    if(context.$store.state.tenant.knumber === 'K10151') {
      makeParams = { opendamagesMax: 1999 }
    }
    dispatch('getMakes', makeParams, { root: true })
    context.$ability.update(defineRulesFor(response.data))
  })
}

export const logout = ({ dispatch }) => {
  //return UserService.logout().then(() => {
  dispatch('clearAuth')
  //});
}

export const setToken = ({ commit, dispatch }, token) => {
  if (isEmpty(token)) {
    return dispatch('checkTokenExists').then(() => {})
  }
  commit('setToken', token)
}

export const checkTokenExists = () => {
  return localforage.getItem('authtoken').then(token => {
    if (isEmpty(token)) {
      return Promise.reject('NO_STORAGE_TOKEN')
    }

    return Promise.resolve(token)
  })
}

export const clearAuth = ({ commit }) => {
  commit('setAuthenticated', false)
  commit('setIsAdmin', false)
  commit('setUserData', null)
  commit('setToken', null)
  commit('SET_MODE', 'merchant', { root: true })
  localforage.removeItem('mode')
  localforage.removeItem('customerType')
  Router.push({ path: '/login' })
}

export const register = ({ dispatch }, { payload, context }) => {
  return UserService.register(payload)
    .then(response => {
      dispatch('clearAuth')
      return response
    })
    .catch(error => {
      context.errors = error.response.data
    })
}
